//
// ResponsiveWidthConstraint.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./ResponsiveSizeConstraint";
import "./VisualSize";

var ResponsiveWidthConstraint = createModule("BIRD::ResponsiveWidthConstraint", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::ResponsiveSizeConstraint"], EventDispatcher, [
    ,
    {
        widths: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ResponsiveWidthConstraint;
